import React, { useState } from "react";
import { useAuth } from "react-oidc-context";

import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import PersonIcon from "@mui/icons-material/Person";

import Filters from "./filters";
import { useNitroStore } from "../../../store/Store";

import "./appBar.css";
import Logo from "./logo";

const AppBar = ({
  searchDisabled,
  defaultProduct,
  disableProductFilter,
  onFooterSelect,
}: {
  searchDisabled: boolean;
  defaultProduct: string;
  disableProductFilter: boolean;
  onFooterSelect?: (tab: any) => void;
}) => {
  const auth = useAuth();

  const [setShowSettingsPanel] = useNitroStore((state) => [
    state.setShowSettingsPanel,
  ]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const logout = () => {
    auth.signoutRedirect();
    auth.clearStaleState();
  };

  return (
    <div
      id="AppBar"
      className={`appBarOutline ${searchDisabled ? "disabled" : ""}`}
    >
      <Logo searchDisabled={searchDisabled} />

      <div
        style={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Filters
          searchDisabled={false}
          defaultProduct={defaultProduct}
          disableProductFilter={disableProductFilter}
          onFooterSelect={onFooterSelect}
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: 4,
        }}
      >
        <IconButton
          id="settings-button"
          size="small"
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            setAnchorEl(event.currentTarget);
          }}
          aria-controls={open ? "settings-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          style={{ borderRadius: 4 }}
          className="profileButton"
        >
          <PersonIcon fontSize="inherit" />
        </IconButton>
        <Menu
          id="settings-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => {
            setAnchorEl(null);
          }}
        >
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              setShowSettingsPanel(true);
            }}
          >
            Settings
          </MenuItem>
          <MenuItem onClick={logout}>Logout</MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default AppBar;
